import { defineComponent as _defineComponent } from 'vue'
import BadgeGoldCommunicationBright from '@/components/svg/badges/badge-communication-gold-brightbg.svg';
import BadgeGoldCommunicationDark from '@/components/svg/badges/badge-communication-gold-darkbg.svg';
import BadgeSilverCommunicationBright from '@/components/svg/badges/badge-communication-silver-brightbg.svg';
import BadgeSilverCommunicationDark from '@/components/svg/badges/badge-communication-silver-darkbg.svg';
import BadgeGoldExpertiseBright from '@/components/svg/badges/badge-expertise-gold-brightbg.svg';
import BadgeGoldExpertiseDark from '@/components/svg/badges/badge-expertise-gold-darkbg.svg';
import BadgeSilverExpertiseBright from '@/components/svg/badges/badge-expertise-silver-brightbg.svg';
import BadgeSilverExpertiseDark from '@/components/svg/badges/badge-expertise-silver-darkbg.svg';
import BadgeMemberBright from '@/components/svg/badges/badge-member-brightbg.svg';
import BadgeMemberDark from '@/components/svg/badges/badge-member-darkbg.svg';
import BadgeGoldNetworkBright from '@/components/svg/badges/badge-network-gold-brightbg.svg';
import BadgeGoldNetworkDark from '@/components/svg/badges/badge-network-gold-darkbg.svg';
import BadgeSilverNetworkBright from '@/components/svg/badges/badge-network-silver-brightbg.svg';
import BadgeSilverNetworkDark from '@/components/svg/badges/badge-network-silver-darkbg.svg';
import BadgeGoldRecommendationsBright from '@/components/svg/badges/badge-recommendations-gold-brightbg.svg';
import BadgeGoldRecommendationsDark from '@/components/svg/badges/badge-recommendations-gold-darkbg.svg';
import BadgeSilverRecommendationsBright from '@/components/svg/badges/badge-recommendations-silver-brightbg.svg';
import BadgeSilverRecommendationsDark from '@/components/svg/badges/badge-recommendations-silver-darkbg.svg';
import BadgeResidentBright from '@/components/svg/badges/badge-resident-brightbg.svg';
import BadgeResidentDark from '@/components/svg/badges/badge-resident-darkbg.svg';
import BadgeSeniorResidentBright from '@/components/svg/badges/badge-senior-resident-brightbg.svg';
import BadgeSeniorResidentDark from '@/components/svg/badges/badge-senior-resident-darkbg.svg';
import BadgeBcTeamBright from '@/components/svg/badges/badge-team-brightbg.svg';
import BadgeBcTeamDark from '@/components/svg/badges/badge-team-darkbg.svg';

import useResponsiveness from '@/mixins/useResponsiveness';

import {
  computed, PropType, toRefs
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXUserBadge',
  props: {
  badge: {
    type: String,
    default: null
  },
  themeMode: {
    type: String as PropType<'Bright' | 'Dark'>,
    default: null
  }
},
  emits: ['badge-clicked'],
  setup(__props, { emit }) {

const props = __props;



const badgeURLsByMode = {
  Dark: {
    GOLD_COMMUNICATION: BadgeGoldCommunicationDark,
    SILVER_COMMUNICATION: BadgeSilverCommunicationDark,
    GOLD_EXPERTISE: BadgeGoldExpertiseDark,
    SILVER_EXPERTISE: BadgeSilverExpertiseDark,
    MEMBER: BadgeMemberDark,
    GOLD_NETWORK: BadgeGoldNetworkDark,
    SILVER_NETWORK: BadgeSilverNetworkDark,
    GOLD_RECOMMENDATIONS: BadgeGoldRecommendationsDark,
    SILVER_RECOMMENDATIONS: BadgeSilverRecommendationsDark,
    RESIDENT: BadgeResidentDark,
    SENIOR_RESIDENT: BadgeSeniorResidentDark,
    BC_TEAM: BadgeBcTeamDark,
  },
  Bright: {
    GOLD_COMMUNICATION: BadgeGoldCommunicationBright,
    SILVER_COMMUNICATION: BadgeSilverCommunicationBright,
    GOLD_EXPERTISE: BadgeGoldExpertiseBright,
    SILVER_EXPERTISE: BadgeSilverExpertiseBright,
    MEMBER: BadgeMemberBright,
    GOLD_NETWORK: BadgeGoldNetworkBright,
    SILVER_NETWORK: BadgeSilverNetworkBright,
    GOLD_RECOMMENDATIONS: BadgeGoldRecommendationsBright,
    SILVER_RECOMMENDATIONS: BadgeSilverRecommendationsBright,
    RESIDENT: BadgeResidentBright,
    SENIOR_RESIDENT: BadgeSeniorResidentBright,
    BC_TEAM: BadgeBcTeamBright,
  },
};



const { badge, themeMode } = toRefs(props);
const { isMobileLayout } = useResponsiveness();

const mode = computed<'Bright' | 'Dark'>(() => {
  if (themeMode.value) {
    return themeMode.value;
  }
  return isMobileLayout.value ? 'Dark' : 'Bright';
});

const badgeURL = computed(() => {
  const badgeName = badge.value.replaceAll(/_?(\s|badge|key)/ig, '') as keyof typeof badgeURLsByMode[typeof mode.value];
  return badgeURLsByMode[mode.value][badgeName];
});

return { __sfc: true,props, badgeURLsByMode, emit, badge, themeMode, isMobileLayout, mode, badgeURL }
}

})